import MedicareSupplement from '@components/pages/medicare-supplement';

const MedicareSupplementPage = () => <MedicareSupplement />;

export default MedicareSupplementPage;
